import { render, staticRenderFns } from "./rulebasedexpert.vue?vue&type=template&id=2d2f40ba&"
import script from "./rulebasedexpert.vue?vue&type=script&lang=js&"
export * from "./rulebasedexpert.vue?vue&type=script&lang=js&"
import style0 from "./rulebasedexpert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports